import { NavigateFunction } from 'react-router-dom';

/**
 * Builds the job search URL for a specific job. Encoding the job id as a
 * real `?jobId=` query param (rather than React Router state) is what makes
 * the link survive being emailed, copied, or opened in a fresh tab.
 */
export function jobSearchPath(jobId: string): string {
  return `/job-search?jobId=${encodeURIComponent(jobId)}`;
}

/**
 * Navigates to the job search page with a specific job selected.
 */
export function navigateToJobSearch(
  navigate: NavigateFunction,
  jobId: string,
  options?: { replace?: boolean }
): void {
  navigate(jobSearchPath(jobId), options);
}
